import { banksProductsInfo } from './banks';
import { businessProductsInfo } from './business';
import { learningTypeInfo } from './education';
import { insuranceProductsInfo } from './insurance';

export const PRODUCTS_INFO = {
  ...banksProductsInfo,
  ...businessProductsInfo,
  ...insuranceProductsInfo,
  ...learningTypeInfo,
};
